module.exports = __webpack_public_path__ + "static/media/logo_vert_black.58e16c54.svg";